import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

/**
 * A component that renders the footer of the application
 *
 * @param {Object} props
 * @param {boolean} whiteBg - A flag that indicates whether the footer should be white
 * @returns {JSX.Element}
 */

export default function Footer({ whiteBg }) {
  const { t } = useTranslation("global");

  return (
    <>
      <div>
        <footer
          className={
            whiteBg
              ? "px-10 bg-text_white md:px-20 py-5 md:py-10"
              : "px-10 bg-[#f6f6f6] md:px-20 py-5 md:py-10"
          }
        >
          <div
            className={clsx(
              "py-4 md:py-0 w-full border-b border-gray-600 flex flex-col md:flex-row items-center justify-between text-black",
              {
                "border-background_steel_blue": whiteBg,
              }
            )}
          >
            <NavLink to="/" className="mb-4">
              <img
                src="./assets/header/LogoSVG.svg"
                alt="Mashrook Trips"
                className="w-16 md:w-20 lg:w-20 h-20 md:h-20 lg:h-20"
              />
            </NavLink>
            <div className="my-2 md:my-4">
              <ul className="flex flex-col items-center mt-2 md:mt-4 font-normal md:font-medium md:flex-row md:items-baseline lg:space-x-8 lg:mt-0"></ul>
            </div>
          </div>
          <div className="mt-4 w-full pb-2 flex flex-col md:flex-row justify-center md:justify-between items-center">
            <div className="mt-3 md:0 text-background_steel_blue">
              {t("footer.copyright_text")}
            </div>
            <div className="flex flex-row justify-end items-center">
              <ul className="flex flex-col md:flex-row justify-start md:justify-start items-center mt-3 text-sm font-medium text-gray-500 dark:text-gray-400 sm:mt-0">
                <li className="mt-3 md:0  text-background_steel_blue">
                  <a
                    href={"/terms-condition"}
                    className="hover:underline me-4 md:me-6"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("footer.items_2.terms_text")}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
